export const truncateString = (str: string, n: number) => {
  if (!str || typeof str !== 'string') return ''
  
  return str.length > n ? str.slice(0, n - 1) + '...' : str
}
